import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BillingProviderRoutingModule} from './billing-provider-routing.module';
import {UnprocessClaimsProvComponent} from './unprocess-claims-prov/unprocess-claims-prov.component';
import {ProcessedClaimsProvComponent} from './processed-claims-prov/processed-claims-prov.component';
import {PaymentsProvComponent} from './payments-prov/payments-prov.component';
import {DenialsProvComponent} from './denials-prov/denials-prov.component';
import {ProvidersBillingModule} from '../providers-billing/providers-billing.module';

@NgModule({
  imports: [
    CommonModule,
    BillingProviderRoutingModule,
    ProvidersBillingModule
  ],
  declarations: [
    UnprocessClaimsProvComponent,
    ProcessedClaimsProvComponent,
    PaymentsProvComponent,
    DenialsProvComponent
  ],
  exports: [
    UnprocessClaimsProvComponent,
    ProcessedClaimsProvComponent,
    PaymentsProvComponent,
    DenialsProvComponent
  ]
})
export class BillingProviderModule { }



// WEBPACK FOOTER //
// ./src/app/pages/billing-provider/billing-provider.module.ts